<template>
  <div id="app">
    <v-app>
      <v-main>
        <v-container fluid>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <div class="text-center my-12">
                <h1 style="color: #495057">LETOUR Admin</h1>
                <Alert v-bind="alertprops" />
              </div>
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Login form</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      prepend-icon="mdi-account"
                      name="login"
                      label="Username"
                      type="text"
                      v-model="username"
                    ></v-text-field>
                    <v-text-field
                      id="password"
                      prepend-icon="mdi-lock"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required]"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                      name="password"
                      label="Password"
                      v-model="password"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <router-link to="/" class="forget">Forget Password?</router-link>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.prevent="loginUser">Login</v-btn>
                </v-card-actions>
              </v-card>
              <div class="text-center mt-12">
                © {{ new Date().getFullYear() }}. All rights reserved.
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Alert from "../../components/Alert";
export default {
  components: {
    Alert,
  },
  data() {
    return {
      username: "VTourAdmin",
      password: "VTourAdmin",
      show: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      alertprops: {
        alertType: "",
        content: "",
        alert: false,
      },
    };
  },

  methods: {
    ...mapActions(["login"]),
    ...mapGetters(["error"]),
    loginUser() {
      let user = {
        username: this.username,
        password: this.password,
      };
      this.login(user)
        .then((res) => {
          if (res.status === 200) this.$router.push("/en/admin/properties");
          else {
            this.getAlertData("error", "Incorrect Password", true);
            setTimeout(() => {
              this.alertprops.alert = false;
            }, 2000);
          }
        })
        .catch(() => {
          console.log("err");
          this.getAlertData("error", "Incorrect Password", true);
        });
    },
    getAlertData(type, content, alert) {
      (this.alertprops.alertType = type),
        (this.alertprops.content = content),
        (this.alertprops.alert = alert);
    },
  },
};
</script>

<style scoped>
#app {
  background-color: #e9ecef;
}
.forget {
  color: #495057;
  text-decoration: none;
  margin-left: 10px;
}
.forget:hover {
  text-decoration: underline;
}
</style>
